import makeWidgetFor from "../../viewModels/makeWidgetFor";
import EshopViewModel from "../../viewModels/eshop/eshopViewModel";
import { registerWidget } from "../widget";
import InitializationWithOutagesService from "services/initialization/initializationWithOutagesService";
import BasicInitializationService from "services/initialization/basicInitializationService";

const EshopWidgetIdentifier = "edaz-eshop";

export default registerWidget({
  component: makeWidgetFor(EshopWidgetIdentifier, [EshopViewModel], InitializationWithOutagesService),
  configuration: {
    tagname: EshopWidgetIdentifier,
  },
});
